import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { followLoginReturnUrl, sanitizeReturnTo } from '../lib/loginReturnUrl';
import { removeStoredQueryParams } from '../utils/queryParamStore';
import { markLoggedOut } from '../lib/loggedOutFlag';

/**
 * Clears the platform session when Academy is reached with `?logout&return_to=`
 * (e.g. from Studio Sign out). Mirrors {@link LoginQueryHandler}.
 */
export function LogoutQueryHandler() {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, loading } = useApp();
  const handledRef = useRef(false);

  useEffect(() => {
    if (loading || handledRef.current) return;

    const params = new URLSearchParams(location.search);
    if (!params.has('logout')) return;

    handledRef.current = true;
    const returnTo = sanitizeReturnTo(params.get('return_to'));

    const cleanUrl = () => {
      params.delete('logout');
      params.delete('return_to');
      const qs = params.toString();
      navigate({ pathname: location.pathname, search: qs ? `?${qs}` : '' }, { replace: true });
      removeStoredQueryParams('logout', 'return_to');
    };

    void (async () => {
      await logout();
      markLoggedOut();
      if (returnTo) {
        followLoginReturnUrl(returnTo, navigate);
        return;
      }
      cleanUrl();
    })();
  }, [loading, location.pathname, location.search, logout, navigate]);

  return null;
}
